import { ReactNode } from 'react'

import { Box, type Colors } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { ArrowLeft } from '@factorialco/f0-react/icons/app'
import { Form } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

import type ContractFlow from 'modules/contracts/lib/ContractFlow'
import { translate } from 'modules/contracts/lib/translate'

interface Props {
  translations: { [key: string]: string }
  flow: ContractFlow
  form: Form
  isCurrentStepCompleted: boolean
  isSubmitting: boolean
  content: ReactNode
  background?: Colors
  onBackButtonClick: () => void
  onNextButtonClick: () => void
  onSubmit: () => void
}

const Footer = ({
  translations,
  flow,
  form,
  isCurrentStepCompleted,
  isSubmitting,
  content,
  background,
  onBackButtonClick,
  onNextButtonClick,
  onSubmit,
}: Props) => {
  const onSubmitConfirmed = () => {
    flow.trackSubmit(form)
    onSubmit()
  }

  const submitButtonCopy = translate(translations, 'submit')

  return (
    <Box
      width="full"
      height="s64"
      paddingX="s24"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      background={background || 'grey100'}
    >
      <Box flexDirection="row" gap="s4" alignItems="center">
        {content}
      </Box>
      <Box flexDirection="row" gap="s8" alignItems="center">
        <F0Button
          variant="outline"
          hideLabel
          label={i18n.t('common.back')}
          disabled={!flow.hasPreviousStep()}
          onClick={() => onBackButtonClick()}
          icon={ArrowLeft}
        />
        {flow.hasNextStep() && (
          <F0Button
            variant="default"
            onClick={() => onNextButtonClick()}
            disabled={!isCurrentStepCompleted}
            label={i18n.t('contract_versions.flows.footer.next')}
          />
        )}
        {flow.isLastStep() && (
          <F0Button
            variant="default"
            onClick={() => onSubmitConfirmed()}
            disabled={!isCurrentStepCompleted || isSubmitting}
            label={submitButtonCopy}
          />
        )}
      </Box>
    </Box>
  )
}

export default Footer
